<template>
  <div>
      <span>{{ popTitle }}</span>
      <el-form :rules="rules"
               ref="form" :model="ruleForm"
               @submit.native.prevent>
        <el-form-item prop="description">
          <el-input autofocus
                    v-model="ruleForm.description"
                    :type="type"
                    :autosize="autosize"
                    @keyup.enter.native="sureEdit('form')">
          </el-input>
        </el-form-item>
        <el-form-item class="des-form-footer">
          <el-button @click="cancelEdit('form')"
                     size="small">
            {{ $t('privateNetwork.cancel') }}
          </el-button>
          <el-button type="primary"
                     size="small"
                     @click="sureEdit('form')">
            {{ $t('privateNetwork.sure') }}
          </el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditValue',
  props: {
    inputVal: {
      type: String,
      default: ''
    },
    popTitle: {
      type: String,
      default: 'popTitle',
    },
    type: {
      type: String,
      default: 'text',
    },
    autosize: {
      type: Object,
      default: () => ({
        minRows: 2,
        maxRows: 4
      })
    },
    inputValRule: {
      type: Array,
      default: () => []
    },
    showEditDes: {
      type: Boolean,
      default: false
    },
    // 判断是否是负载均衡编辑
    isLbEdit: {
      type: Boolean,
      default: false
    },
    // 负载均衡实例修改名称时校验使用
    region: {
      type: String,
      default: ''
    }
  },
  data() {
    /**
     * 校验负载均衡实例名称是否重复
     * @param rule
     * @param value
     * @param callback
     */
    const validateHostName = (rule, value, callback) => {
      if (value !== this.inputValue) {
        this.checkSlbName(value).then((isDuplication) => {
          console.log(isDuplication, 'isPassCheck');
          if (isDuplication) {
            this.ruleForm.isDuplicate = true;
            callback(new Error(this.$t('slb.serverGroup.nameDuplicate')));
          } else {
            this.ruleForm.isDuplicate = false;
            callback();
          }
        });
      } else {
        callback();
      }
    };
    return {
      rules: {
        description: this.inputValRule
      },
      ruleForm: {
        description: this.inputVal
      },
    };
  },
  methods: {
    /**
     * 检查名称是否重复
     * @param name
     * @return String
     */
    async checkSlbName(name) {
      const params = {
        region: this.region,
        name
      };
      const json = await Ajax.get('/api/cps/checkSlbsName', params)
        .then(res => res.data.success);
      return json;
    },
    cancelEdit(formName) {
      this.$emit('update:showEditDes', false);
      this.$refs[formName].clearValidate();
      this.$refs[formName].resetFields();
    },
    sureEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //this.$emit('update:inputVal', this.ruleForm.description);
          this.$emit('sureEdit', this.ruleForm.description);
          this.cancelEdit(formName);
        } else {
          return false;
        }
      });
    }
  },
  created() {
    if (this.isLbEdit) {
      const validateHostName = (rule, value, callback) => {
        console.log(this.inputVal, 'input---value');
        if (value !== this.inputVal) {
          this.checkSlbName(value).then((isDuplication) => {
            console.log(isDuplication, 'isPassCheck');
            if (isDuplication) {
              this.ruleForm.isDuplicate = true;
              callback(new Error(this.$t('slb.serverGroup.nameDuplicate')));
            } else {
              this.ruleForm.isDuplicate = false;
              callback();
            }
          });
        } else {
          callback();
        }
      };
      this.inputValRule.push({
        validator: validateHostName,
        trigger: 'blur'
      });
    }
  }
};
</script>

<style scoped lang="scss">
  .des-form {
    display: inline-block;
  }

  .des-form-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/privateNetwork/EditValue.vue